import { FETCH_DEVICE, UPDATE_DEVICE_IP } from './../constants';
import { handleActions } from "redux-actions"

export const devices  = handleActions(
  {
    [ FETCH_DEVICE ]: (state, action) => {
      // alert('asignado ' + JSON.stringify(action.payload.data))
      return action.payload.data
    },
    [ UPDATE_DEVICE_IP ]: (state, action) => {
      return {...state, ip: action.payload.ip}
    }
  }, {}
)